import { TDocument } from './doc-base';
import { DOC_TYPE_USER, TDocUser } from './user';
import { newDocument } from 'shared/constants/docs';
import { TDocProject } from 'shared/model/project';

export type TDoc = TDocUser | TDocProject;
export type TDocType = typeof DOC_TYPE_USER;

// export function getEmptyDoc(type: typeof DOC_TYPE_USER, userId: string): TDocUser;
export function getEmptyDoc<T extends TDocument>(type: TDocType): T {
	switch (type) {
		case DOC_TYPE_USER:
			return (newDocument(type)) as unknown as T; // TODO: how to convert to T type properly?
		// default: break;
	}
}
